// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import SearchPaging from "./../../factories/search-paging";
import TabController from "./../../factories/tab-controller";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import * as moment from "moment";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function BookHoursDetailViewModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem100Activity = parent;
    self.BookHoursDetailCollection = ko.observableArray([]);
    self.BookHoursDetailTotalRows = ko.observable(0);
    self.BookHoursDetailSorting = ko.observableArray();
    self.BookHoursDetailSorting.subscribe(function () {
        self.RefreshBookHoursDetailGrid();
    });
    self.SelectBookHoursDetailRow = function (item) {
        self.SelectedBookHoursDetailRow(item);
        return true;
    };
    self.SelectedBookHoursDetailRow = ko.observable({});
    self.SelectedBookHoursDetailRow.subscribe(function () {
        self.ToggleBookHoursDetailToolbarButtons();
    });
    self.BookHoursDetailToolbarButtons = ko.observableArray();
    self.BookHoursDetailToolbarButtons.subscribe(function () {
        self.ToggleBookHoursDetailToolbarButtons();
    });
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    var _deleteMessageBookHoursDetail = Bao.Session.GetMessage("msgDeleteBookHoursDetail");
    var initialized = false;
    self.GetMinutesOfJs = function (js) {
        var minutes = 0;
        if (!Bao.Utils.String.IsNullOrEmpty(js)) {
            var m = moment(js, Bao.Utils.DateTimeFormat);
            minutes = m.minutes();
            minutes = minutes + m.hours() * 60;
        }
        return minutes;
    };
    self.GetMomentOfMinutes = function (minutes) {
        var m = moment("20000101000000", Bao.Utils.DateTimeFormat);
        if (minutes < 0) {
            m = m.add(minutes * -1, "m");
        }
        else {
            m = m.add(minutes, "m");
        }
        return m;
    };
    self.TotalTimeJs = ko.computed(function () {
        var totalTimeJs = "20000101000000";
        var totalTime = moment(totalTimeJs, Bao.Utils.DateTimeFormat);
        if (self.BookHoursDetailCollection != null) {
            ko.utils.arrayForEach(self.BookHoursDetailCollection(), function (item: any) {
                var totalTimeItem = moment(item.TotalTimeJs, Bao.Utils.DateTimeFormat);
                if (totalTimeItem != null && totalTimeItem.isValid()) {
                    totalTime = totalTime.add(totalTimeItem.hours(), "h");
                    totalTime = totalTime.add(totalTimeItem.minutes(), "m");
                }
            });
        }
        return totalTime.format(Bao.Utils.DateTimeFormat);
    });
    self.HourHeaderForegroundStyle = ko.observable("#000000");
    self.HourHeader = ko.computed(function () {
        var s = Bao.Session.GetMessage("msgHoursHours")();
        var minutesProjects = self.GetMinutesOfJs(self.TotalTimeJs());
        var minutesHeader = self.GetMinutesOfJs(self.ConfigurationItem100Activity.TotalTimeJs());
        var differenceMinutes = minutesProjects - minutesHeader;
        if (differenceMinutes < 0) {
            differenceMinutes = differenceMinutes * -1;
        }
        var differenceMoment = self.GetMomentOfMinutes(differenceMinutes);
        if (minutesProjects > minutesHeader) {
            s = s + " (" + differenceMoment.format("HH:mm") + "<span class='fal fa-exclamation-triangle'/></span>)";
            self.HourHeaderForegroundStyle("#ff0000");
        }
        if (minutesProjects < minutesHeader) {
            s = s + " (-" + differenceMoment.format("HH:mm") + "<span class='fal fa-exclamation-triangle'/></span>)";
            self.HourHeaderForegroundStyle("#ff0000");
        }
        if (minutesProjects == minutesHeader) {
            s = s;
            self.HourHeaderForegroundStyle("#000000");
        }
        return s;
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "AddConfigurationItem100ActivityDetail":
                self.ShowBookHoursDetailDialog(self.ConfigurationItem100Activity.ConfigurationItem100ActivityId(), self.ConfigurationItem100Activity.ConfigurationItemId(), null);
                break;
            case "EditConfigurationItem100ActivityDetail":
                self.EditBookHoursDetail(self.SelectedBookHoursDetailRow());
                break;
            case "DeleteConfigurationItem100ActivityDetail":
                if (self.SelectedBookHoursDetailRow() != null) {
                    var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageBookHoursDetail, "yesno");
                    yesNoDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.DeleteBookHoursDetail(self.ConfigurationItem100Activity.ConfigurationItem100ActivityId(), self.SelectedBookHoursDetailRow().ConfigurationItem100ActivityDetailId);
                        }
                    });
                }
                break;
        }
    };
    self.ToggleBookHoursDetailToolbarButtons = function () {
        ko.utils.arrayForEach(self.BookHoursDetailToolbarButtons(), function (button : any) {
            if (button.ActionKey() == "DeleteConfigurationItem100ActivityDetail" || button.ActionKey() == "EditConfigurationItem100ActivityDetail") {
                button.Enabled(self.SelectedBookHoursDetailRow() != null);
            }
        });
    };
    self.RefreshBookHoursDetailGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("BookHours/GetConfigurationItem100ActivityDetailCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId(),
            configurationItem100ActivityId: self.ConfigurationItem100Activity.ConfigurationItem100ActivityId(),
            pageIndex: 0,
            pageSize: 0,
            sorting: self.BookHoursDetailSorting()
        }), function (searchResult) {
            self.SelectedBookHoursDetailRow(null);
            self.BookHoursDetailTotalRows(0);
            self.BookHoursDetailCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.BookHoursDetailCollection(searchResult.Models);
                self.BookHoursDetailTotalRows(searchResult.TotalRows);
                self.ToggleBookHoursDetailToolbarButtons();
            }
            tabPage.IsLoading(false);
        });
    };
    self.EditBookHoursDetail = function (item) {
        if (item != null) {
            self.ShowBookHoursDetailDialog(self.ConfigurationItem100Activity.ConfigurationItem100ActivityId(), self.ConfigurationItem100Activity.ConfigurationItemId(), item.ConfigurationItem100ActivityDetailId);
        }
    };
    self.AddBookHoursDetail = function (model, configurationItem100ActivityId) {
        tabPage.IsLoading(true);
        var detailModel = ko.map.toJS(model);
        delete detailModel.SelectedProject;
        return Bao.post("BookHours/AddConfigurationItem100ActivityDetail", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId(),
            detailModel: detailModel,
            configurationItem100ActivityId: configurationItem100ActivityId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshBookHoursDetailGrid();
        });
    };
    self.DeleteBookHoursDetail = function (configurationItem100ActivityId, configurationItem100ActivityDetailId) {
        tabPage.IsLoading(true);
        return Bao.post("BookHours/DeleteConfigurationItem100ActivityDetail", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId(),
            configurationItem100ActivityId: configurationItem100ActivityId,
            configurationItem100ActivityDetailId: configurationItem100ActivityDetailId
        }), function () {
            parent.TabPage.DirtyFlag(true);
            self.RefreshBookHoursDetailGrid();
        });
    };
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("700px");
    self.Dialog.Buttons([{
            Title: _msgOk,
            Click: function () {
                if (self.Dialog.ViewModel().CompleteCheck() == true) {
                    self.AddBookHoursDetail(self.Dialog.ViewModel(), self.ConfigurationItem100Activity.ConfigurationItem100ActivityId());
                    self.Dialog.Close();
                }
            },
            Enabled: ko.observable(true)
        }, {
            Title: _msgCancel,
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.ShowBookHoursDetailDialog = function (configurationItem100ActivityId, personId, configurationItem100ActivityDetailId) {
        Bao.post("BookHours/ShowConfigurationItem100ActivityDetailDialog", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId(),
            configurationItem100ActivityId: configurationItem100ActivityId,
            configurationItem100ActivityDetailId: configurationItem100ActivityDetailId
        }), function (value) {
            self.Dialog.ViewModel(ko.map.fromJS(value.Model));
            self.Dialog.ViewModel().Focus = function () { };
            self.Dialog.ViewModel().BreakJs.subscribe(function () {
                self.Dialog.ViewModel().CalculateTotalTime();
            });
            self.Dialog.ViewModel().BeginJs.subscribe(function () {
                self.Dialog.ViewModel().CalculateTotalTime();
            });
            self.Dialog.ViewModel().EndJs.subscribe(function () {
                self.Dialog.ViewModel().CalculateTotalTime();
            });
            self.Dialog.ViewModel().PersonId = ko.observable();
            self.Dialog.ViewModel().PersonId(personId);
            self.Dialog.ViewModel().DateJs = ko.observable();
            self.Dialog.ViewModel().DateJs(self.ConfigurationItem100Activity.DateJs());
            self.Dialog.ViewModel().ConfigurationItemTypeId.subscribe(function () {
                self.Dialog.ViewModel().ProjectId(null);
                self.Dialog.ViewModel().ProjectName("");
                self.Dialog.ViewModel().ProjectNumber("");
                self.Dialog.ViewModel().ProjectNumberName("");
                self.Dialog.ViewModel().CustomerHourBookingTimeMandatory(false);
            });
            self.Dialog.ViewModel().ProjectId.subscribe(function () {
                self.Dialog.ViewModel().SubProjectId(null);
                self.Dialog.ViewModel().SubProjectNumberName("");
                if (self.Dialog.ViewModel().ProjectId() != null) {
                    self.Dialog.IsLoading(true);
                    Bao.post("BookHours/GetDefaultSubProject", JSON.stringify({
                        projectId: self.Dialog.ViewModel().ProjectId(),
                        personId: self.ConfigurationItem100Activity.ConfigurationItemId()
                    }), function (result) {
                        if (result != null) {
                            self.Dialog.ViewModel().SubProjectId(result.ConfigurationItemId);
                            self.Dialog.ViewModel().SubProjectNumberName(result.NumberName);
                        }
                        self.Dialog.IsLoading(false);
                    });
                }
            });
            self.Dialog.ViewModel().SubProjectId.subscribe(function () {
                self.Dialog.ViewModel().QualificationId(null);
                self.Dialog.ViewModel().QualificationName("");
                if (self.Dialog.ViewModel().ProjectId() != null) {
                    self.Dialog.IsLoading(true);
                    Bao.post("BookHours/GetDefaultQualification", JSON.stringify({
                        subProjectId: self.Dialog.ViewModel().SubProjectId(),
                        personId: self.ConfigurationItem100Activity.ConfigurationItemId()
                    }), function (result) {
                        if (result != null) {
                            self.Dialog.ViewModel().QualificationId(result.QualificationId);
                            self.Dialog.ViewModel().QualificationName(result.Name);
                        }
                        self.Dialog.IsLoading(false);
                    });
                }
            });
            self.Dialog.ViewModel().SelectedProject = ko.observable();
            self.Dialog.ViewModel().SelectedProject.subscribe(function (item) {
                if (item != null) {
                    self.Dialog.ViewModel().ProjectName(item.Name1);
                    self.Dialog.ViewModel().ProjectNumber(item.Number);
                    self.Dialog.ViewModel().ProjectNumberName(item.NumberName);
                    self.Dialog.ViewModel().CustomerHourBookingTimeMandatory(item.CustomerHourBookingTimeMandatory);
                }
                else {
                    self.Dialog.ViewModel().ProjectName("");
                    self.Dialog.ViewModel().ProjectNumber("");
                    self.Dialog.ViewModel().ProjectNumberName("");
                    self.Dialog.ViewModel().CustomerHourBookingTimeMandatory(null);
                }
            });
            self.Dialog.ViewModel().CalculateTotalTime = function () {
                var beginDate = moment(self.Dialog.ViewModel().BeginJs(), Bao.Utils.DateTimeFormat);
                var endDate = moment(self.Dialog.ViewModel().EndJs(), Bao.Utils.DateTimeFormat);
                var breakTime = moment(self.Dialog.ViewModel().BreakJs(), Bao.Utils.DateTimeFormat);
                if (beginDate != null && beginDate.isValid() && endDate != null && endDate.isValid()) {
                    if (beginDate.isBefore(endDate)) {
                        var duration = moment.duration(endDate.diff(beginDate));
                        if (breakTime != null && breakTime.isValid) {
                            duration = duration.subtract(breakTime.hours(), "h");
                            duration = duration.subtract(breakTime.minutes(), "m");
                        }
                        // TODO: here was a bug in js - duration format could be wrong
                        self.Dialog.ViewModel().TotalTimeJs(duration.asSeconds());
                    }
                }
            };
            self.Dialog.ViewModel().CompleteCheck = function () {
                var isComplete = true;
                if (self.Dialog.ViewModel().ProjectId() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().SubProjectId() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().QualificationId() == null) {
                    isComplete = false;
                }
                if (self.Dialog.ViewModel().CustomerHourBookingTimeMandatory() == true) {
                    if (Bao.Utils.String.IsNullOrWhitespace(self.Dialog.ViewModel().BeginJs())) {
                        isComplete = false;
                    }
                    if (Bao.Utils.String.IsNullOrWhitespace(self.Dialog.ViewModel().EndJs())) {
                        isComplete = false;
                    }
                }
                if (isComplete == false) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
                return isComplete;
            };
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            self.Dialog.ViewModel().Focus();
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("BookHours/ResetConfigurationItem100ActivityDetail", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId()
        }), function () {
            self.RefreshBookHoursDetailGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function (savetime) {
        return Bao.post("BookHours/SaveConfigurationItem100ActivityDetail", JSON.stringify({
            sessionTabId: self.ConfigurationItem100Activity.SessionTabId(),
            configurationItem100ActivityId: self.ConfigurationItem100Activity.ConfigurationItem100ActivityId(),
            saveTime: savetime
        }));
    };
    self.loaded = function () {
        var def = $.Deferred();
        self.Refresh().then(function () {
            initialized = true;
            def.resolve();
        });
        return def.promise();
    };
}
export default BookHoursDetailViewModel;